import type { ComputedRef, InjectionKey } from 'vue'
import type { TabManager } from './types/tabs'
import type { AffixManager } from './types/affix'
import type { HeaderInjector } from './types/modal'
import type { RadioGroupProvider } from './types/radioGroup'
import type { DropdownProvider } from './types/dropdown'
import type { PopoverProvider } from './types/popover'
import type { FieldComboboxProvider, FieldGroupProvider, FieldInputWrapperProvider, FieldProvider, FieldSelectProvider } from './types/field'

export const DTModalHeaderInjector = Symbol('DTModalHeaderInjector') as InjectionKey<HeaderInjector>
export const DTTabManagerInjector = Symbol('DTTabManagerInjector') as InjectionKey<ComputedRef<TabManager>>
export const DTAffixManagerInjector = Symbol('DTAffixManagerInjector') as InjectionKey<AffixManager>

export const DTFieldProvider = Symbol('DTFieldProvider') as InjectionKey<FieldProvider>
export const DTFieldGroupProvider = Symbol('DTFieldGroupProvider') as InjectionKey<FieldGroupProvider>
export const DTFieldInputWrapperProvider = Symbol('DTFieldInputWrapperProvider') as InjectionKey<FieldInputWrapperProvider>

export const DTFieldSelectProvider = Symbol('DTFieldSelectProvider') as InjectionKey<FieldSelectProvider>
export const DTFieldComboboxProvider = Symbol('DTFieldComboboxProvider') as InjectionKey<FieldComboboxProvider>

export const DTRadioGroupProvider = Symbol('DTRadioGroupProvider') as InjectionKey<RadioGroupProvider>
export const DTDropdownProvider = Symbol('DTDropdownProvider') as InjectionKey<DropdownProvider>
export const DTPopoverProvider = Symbol('DTPopoverProvider') as InjectionKey<PopoverProvider>
